import { Row } from '@atom-web/micros'

import { Slider } from './Slider'
export default ({ resorts = [], displayCurrency, testimonial = {} }) => {
	return (
		<Row
			css={{
				width: '100%',
				paddingBottom: '$4',
				gap: '24px',
			}}
		>
			<Slider
				resorts={resorts.filter(resort => resort)}
				displayCurrency={displayCurrency}
				testimonial={testimonial}
			/>
		</Row>
	)
}
